import queryString from 'querystring';
import React, { useEffect, useState } from 'react';
// @ts-ignore
import { isAndroidChrome, isIOS } from '../../../helpers/serverRenderingUtils';
import Spinner from '../../components/Spinner';
import { AnchorAPI } from '../../modules/AnchorAPI';
import { fetchUserVerificationState } from '../../modules/AnchorAPI/user/fetchUserVerificationState';
import { UserVerificationState } from '../../modules/AnchorAPI/user/verifyUserEmail';
import { Button } from '../../shared/Button/NewButton';
import Icon from '../../shared/Icon';
import { setUserVerificationState } from '../../user';
import * as styles from './styles.sass';

type VerifyUserEmailScreenProps = {
  location: {
    search: string;
  };
};

export function VerifyUserEmailScreen({
  location: { search },
}: VerifyUserEmailScreenProps) {
  const [userVerificationSuccess, setUserVerificationSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  function redirectToLogin() {
    window.location.href = `/login?return_to=${encodeURI(
      window.location.pathname + window.location.search
    )}`;
  }
  useEffect(() => {
    fetchUserVerificationState()
      .then(({ userVerificationState, userId }) => {
        // queryString prepends the key with `?`; we remove it to get clean keys
        const { code } = queryString.parse(search.slice(1));
        if (!code && !userVerificationSuccess) {
          redirectToLogin();
        }
        if (userVerificationState === 'legacyOrSocialSignOnUser') {
          return setUserVerificationSuccess(true);
        }
        // @ts-ignore
        AnchorAPI.verifyUserEmail({ code, userId })
          .then(
            ({
              userVerificationState: verificationState,
            }: {
              userVerificationState: UserVerificationState;
            }) => {
              if (verificationState) {
                setUserVerificationState({
                  userVerificationState: verificationState,
                });
                setUserVerificationSuccess(true);
              }
            }
          )
          .catch((err: Error) => {
            setUserVerificationSuccess(true);
            setErrorMessage(
              'We are unable to verify your email. If you need more help, please reach out to help.anchor.fm'
            );
            console.log(err);
          });
      })
      .catch((err: Error) => {
        if (err.message === 'Not logged in') {
          return redirectToLogin();
        }
        setUserVerificationSuccess(true);
        setErrorMessage(
          'We are unable to verify your email. If you need more help, please reach out to help.anchor.fm'
        );
      });
  }, []);
  const isMobile = isAndroidChrome() || isIOS();
  return (
    <div className={styles.screen}>
      <div className={styles.container}>
        {userVerificationSuccess ? (
          <React.Fragment>
            <div className={styles.emailIcon}>
              {!errorMessage && <Icon type="EmailVerified" />}
            </div>
            <h1 className={styles.title}>
              {errorMessage
                ? "We're having trouble right now"
                : 'Email verified'}
            </h1>
            <p className={styles.copy}>
              {errorMessage ||
                "Great! Now you can publish an episode whenever you're ready."}
            </p>
            {isMobile && (
              <Button
                kind="link"
                color="purple"
                className={styles.button}
                href="AnchorFM://anchor.fm/emailVerification"
              >
                Open in Anchor
              </Button>
            )}
            <Button color="white" href="/dashboard" kind="link">
              Continue to dashboard
            </Button>
          </React.Fragment>
        ) : (
          <Spinner color="gray" />
        )}
      </div>
    </div>
  );
}
